import { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Form, Button } from 'antd';

const AddStripeCardForm = ({ closeStripeAddModal }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loader, setLoader] = useState(false);
  const [errorCardMessage, setErrorCardMessage] = useState(null);

  const handlepageLoaderModalOpen = async (event) => {
    setLoader(true);
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    try {
      const payementResult = await stripe.confirmSetup({
        elements,
        redirect: 'if_required',
      });

      if (payementResult.error) {
        setErrorCardMessage(payementResult?.error?.message);
        setTimeout(() => {
          setErrorCardMessage(null);
        }, 2000);
      } else {
        closeStripeAddModal(true); // fetch new card
      }
    } catch (error) {
      console.error('Error while add stripe card: ', error);
    } finally {
      setLoader(false);
    }
  };

  const setShowCreditCard = () => {
    closeStripeAddModal();
  };

  const paymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false, // This mainly applies to accordion; for tabs, it ensures visibility if applicable
    },
  };

  return (
    <Form>
      <div className="">
        <PaymentElement options={paymentElementOptions} />
      </div>
      {errorCardMessage ? <small className="text-danger mb-3 d-block">{errorCardMessage}</small> : ''}
      <div className="d-flex justify-content-end stripe-card-btn">
        <Button className="" onClick={() => setShowCreditCard()} disabled={loader ? true : false}>
          Cancel
        </Button>

        <Button className="" type="primary" onClick={handlepageLoaderModalOpen} disabled={loader || !stripe || !elements}>
          Submit
        </Button>
      </div>
    </Form>
  );
};

export default AddStripeCardForm;
